import { render, staticRenderFns } from "./GenList.vue?vue&type=template&id=b90e71c2&"
import script from "./GenList.vue?vue&type=script&lang=js&"
export * from "./GenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports